import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

export class UsersService extends BaseService {
  static get entity () {
    return 'v1/users'
  }

  static async getCurrent() {
    try {
      const response = await this.request({ auth: true }).get(`${this.entity}/current`)      
      return new ResponseWrapper(response, response.data)      
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async changePassword(password) {
    try {      
      const response = await this.request({ auth: true }).patch(
        `${this.entity}/password`,
        {
          password: password,
        },
      );
      return new ResponseWrapper(response, response.data)      
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async changeEmail(email) {
    try {      
      const response = await this.request({ auth: true }).patch(
        `${this.entity}/email`,
        {
          email: email,
        },
      );
      return new ResponseWrapper(response, response.data)      
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}
